export default __webpack_public_path__ + "static/media/aws-codedeploy.87d9d022.svg";